export default () => ({
  ColorPicker: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '90%'
  }
})
